import { useMemo } from 'react';

import { Role } from 'models/user';

import { useOutletContext } from './useOutletContext';

export const useRole = (roles: Role | Role[]) => {
  const { role: userRole } = useOutletContext();

  const isAccessAllowed = useMemo(() => {
    if (typeof roles === 'string') {
      return roles === userRole;
    } else {
      return roles.includes(userRole);
    }
  }, []);

  return isAccessAllowed;
};
